import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';
import Home from '../pages/Home';
import Shows from '../pages/Shows';
import Press from '../pages/Press';
import Contact from '../pages/Contact';

const Layout: React.FC = () => {
  return (
    <div className="site-root">
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Navigate to="/#about" replace />} />
          <Route path="/shows" element={<Shows />} />
          <Route path="/press" element={<Press />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
